<template>
  <div animation="fade" :only-fade="true" class="review-tabs">
    <template v-if="reviewResultsWithComments.length">
      <collapse-component accordion is-fullwidth>
        <collapse-item
          v-for="result in reviewResultsWithComments"
          ref="collapseItem"
          v-bind="{ itemId: result.id }"
          :key="result.id"
          v-on:toggled="toggleCollapseItemCallback($event)"
          :title="getCollapseItemTitle(result)">
          <div v-if="result.comments.length" class="comments-section">
            <comment-component
              v-for="(comment, index) in result.comments"
              :key="index"
              :comment="comment">
            </comment-component>
          </div>
          <template v-if="formDescriptors && formDatas">
            <form-component
              v-for="formDescriptor in formDescriptors"
              :formDescriptor="formDescriptor"
              :formData="getFormDataForDescriptor(formDescriptor)"
              :key="formDescriptor.id">
            </form-component>
          </template>
          <div class="field is-grouped">
            <div class="control">
              <submit-btn-component class="is-primary" @submit="submitComment($event, result.id)">Save</submit-btn-component>
            </div>
            <div class="control">
              <button class="button is-danger is-outlined" @click="toggleCollapseItem(result.id)" v-translate>Cancel</button>
            </div>
          </div>
        </collapse-item>
      </collapse-component>
    </template>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import CollapseComponent from '@/components/layout/collapse/Collapse'
  import CollapseItem from '@/components/layout/collapse/Item'
  import CommentComponent from '@/components/layout/utility/CommentComponent'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'
  import { formHandlerMixin } from '@/mixins/mixins'
  import FormComponent from '@/components/form/FormComponent'

  export default {
    name: 'case-review-comments-view',
    mixins: [formHandlerMixin],
    props: {
      caseId: {
        required: true
      }
    },
    components: {
      SubmitBtnComponent,
      CommentComponent,
      CollapseComponent,
      CollapseItem,
      FormComponent
    },
    computed: {
      ...mapState({
        reviewResults: state => state.caseReviewModule.reviewResults,
        comments: state => state.commentModule.comments,
        formDescriptors: state => state.commentModule.commentFormDescriptors,
        formDatas: state => state.commentModule.commentFormDatas
      }),
      ...mapGetters([
        'getReviewResultForId',
        'getReviewResultsWithComments'
      ]),
      reviewResultsWithComments () {
        this.findAndToggleCollapseItem()
        return this.getReviewResultsWithComments
      }
    },
    methods: {
      ...mapActions([
        'saveFinding',
        'updateFinding',
        'getComments',
        'setupCommentForm',
        'createCommentForm'
      ]),
      ...mapMutations([
        'commitPendingFinding'
      ]),
      getCollapseItemTitle (result) {
        let commentCount = result.comments ? result.comments.length : 0
        return `${result.getLabel()} (${commentCount})`
      },
      submitComment (btn, reviewResultId) {
        let requestData = {
          reviewResultId: reviewResultId,
          formDatas: this.formDatas
        }
        this.mixin.callbackData = reviewResultId
        this.submitRequest = this.createCommentForm
        this.submitForm(requestData, btn, this.submitCommentCallback)
      },
      submitCommentCallback (response, reviewResultId) {
        let requestData = {
          reviewResultId: reviewResultId
        }
        this.getComments(requestData).then(() => {
          this.getReviewResultForId(reviewResultId).setComments(this.comments)
          this.toggleCollapseItem(reviewResultId)
        }).catch((err) => {
          this.handleError(err)
        })
      },
      resetComment () {
        for (let formData of this.formDatas) {
          for (let field in formData.fields) {
            formData.fields[field].value = null
          }
        }
      },
      getCollapseItemForReviewResult (reviewResultId) {
        return this.$refs.collapseItem && reviewResultId ? this.$refs.collapseItem.find((collapseItem) => {
          return collapseItem.itemId === reviewResultId
        }) : null
      },
      findAndToggleCollapseItem () {
        let reviewResult = this.reviewResults.find((reviewResult) => {
          return reviewResult.triggerToggle
        })
        if (reviewResult) {
          this.$nextTick(() => {
            this.toggleCollapseItem(reviewResult.id)
          })
        }
      },
      toggleCollapseItem (reviewResultId) {
        let collapseItem = this.getCollapseItemForReviewResult(reviewResultId)
        collapseItem && collapseItem.toggle()
      },
      toggleCollapseItemCallback (collapseItem) {
        collapseItem.isActive && this.setupReviewResultCommentForm(collapseItem.itemId, collapseItem)
      },
      setupReviewResultCommentForm (reviewResultId, collapseItem) {
        this.setupCommentForm(reviewResultId).then(() => {
          collapseItem.focusInput()
        }).catch((err) => {
          this.handleError(err)
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  .form-component
    margin-top: 0
</style>
